<template>
  <section class="map container" ref="animatedSection">
    <div class="map-inner">
      <ul class="map-wrapper clearfix">

        <li class="map-list text">
          <div class="title-box" ref="mapTitleBox">
            <p class="deco-text">Join AXIS</p>
            <p class="sub-font">
              주님의 이름으로 환영합니다.<br>
              <span>오셔서 함께 예배드려요!</span>
            </p>
            <p class="bible">
              모이기를 폐하는 어떤 사람들의 습관과 같이 하지 말고<br>
              오직 권하여 그 날이 가까움을 볼수록 더욱 그리하자<br>
              <span>- Hebrews 10: 25 -</span>
            </p>
          </div>

        </li>
        <li class="map-list kakao-map" ref="mapContent">
          <div class="kakao-map-container" ref="kakaoMapContainer">
            <KakaoMap />
          </div>
          <div class="content" ref="mapExplanation">
            <p class="time-and-floor content-text">
              <span>[젊은이부 예배장소 & 시간]</span><br>
              천호제일교회 4층 벧엘 성전, 주일 오후 2시<br>
              <span class="important">
                  한 달에 주일이 다섯번 있는 경우, 마지막(다섯번째) 주일은 '패밀리주일'로 젊은이부 예배가 없습니다. 본교회 예배를 드려주세요!<br>
                  <span style="color: #555; font-weight: 400">- 본교회 예배 (1부 : 주일 오전 09:00분, 2부 : 주일 오전 11:15분) 지하 2층 예루살렘 성전</span>
                </span>
            </p>
            <p class="address-and-tel content-text">
              <span>[주소]</span><br>
              서울특별시 강동구 천중로27길 51 (서울특별시 강동구 천호동 219-2)
            </p>
            <p class="detail content-text">
              5호선 굽은다리역 2번출구 → 천호중학교 방향 계속 직진 → 천호중학교 지나면 약간의 언덕이 나옵니다.<br>
              언덕을 내려서면서 첫번째 횡단보도 신호등에서 좌측 골목(표지판)으로 약70m 위치<br>
              천호1동사무소와 공원이 함께 있습니다.
            </p>
          </div>
        </li>

      </ul>
    </div>
  </section>
</template>
<script>
import KakaoMap from "@/components/core/KakaoMap.vue";

export default {
  name: "Map",
  components: {KakaoMap},
  props: {

  },
  mounted() {
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -150px 0px',  // 뷰포트 하단에서 200px 지나야만 트리거
      threshold: 0  // 요소의 30%가 보일 때 트리거
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 요소가 보이면 isVisible을 true로 설정
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    observer.observe(this.$refs.animatedSection);
    observer.observe(this.$refs.kakaoMapContainer);
    observer.observe(this.$refs.mapTitleBox);
    observer.observe(this.$refs.mapExplanation);
  }
}
</script>

<style scoped lang="scss">
.map {
  box-sizing: border-box;
  padding-top: 120px;
  padding-bottom: 140px;

  .map-inner {

    .map-wrapper {
      max-width: 1280px;
      width: 100%;
      margin: 0 auto;
      background-color: #fff;

      .map-list {
        float: left;
        box-sizing: border-box;
        padding: 10px;
        width: 100%;
        text-align: left;

        &.text {
          text-align: left;
          margin-bottom: 20px;

          .title-box {

            position: relative;

            opacity: 0;
            transform: translatey(150px);
            transition: all .3s ease-out;

            &.visible {
              opacity: 1;
              transform: translatey(0);
            }

            .deco-text {
              position: absolute;
              top: -35px;
              left: 10px;
              font-family: "Montserrat", sans-serif;
              font-optical-sizing: auto;
              font-weight: 900;
              color: #f3f3f3;
              font-size: 60px;
              z-index: 0;
            }

            h2 {

              color: #000;
              margin-top: 40px;
            }

            .sub-font {
              position: relative;
              z-index: 1;
              font-size: 26px;
              line-height: 1.4;
              font-weight: 300;
              color: #333;

              span {
                font-size: 30px;
                font-weight: 700;
                color: #333;
              }
            }

            .bible {
              font-size: 15px;
              color: #888;
              line-height: 1.4;

              span {
                display: inline-block;
                margin-top: 5px;
                font-style: italic;
              }
            }
          }



        }

        &.kakao-map {

          .kakao-map-container {

            opacity: 0;
            transform: translatey(150px);
            transition: all .3s ease-out;

            &.visible {
              opacity: 1;
              transform: translatey(0);
            }

          }

          .content {

            opacity: 0;
            transform: translatey(50px);
            transition: all .3s ease-out;

            &.visible {
              opacity: 1;
              transform: translatey(0);
            }

            line-height: 1.5;
            font-size: 16px;
            margin-top: 30px;
            color: #555;

            .content-text {
              &.time-and-floor {
                span {
                  font-weight: 700;
                  color: #333;

                  &.important {
                    color: #FF6F61;
                    font-weight: 400;
                  }
                }
              }
              &.address-and-tel {
                margin-top: 10px;
                span {
                  font-weight: 700;
                  color: #333;
                }
              }
              &.detail {
                margin-top: 20px;
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1512px) {
 .map-inner {
   box-sizing: border-box;
   padding: 15px;
 }

}

@media screen and (max-width: 768px) {

  .container {
    padding-top: 60px;
    padding-bottom: 60px;
  }

  .map .map-inner .map-wrapper .map-list.text .title-box .sub-font span {
    font-size: 26px;
  }

  .map .map-inner .map-wrapper .map-list.text .title-box .deco-text {
    font-size: 40px;
    top: -26px;
  }

  .map .map-inner .map-wrapper .map-list.kakao-map .content {
    font-size: 15px;
  }

}
</style>